import { z } from "zod";

import { PHONE_NUMBER_REQUIRED_MESSAGE, SMS_PHONE_NUMBER_FORMAT_MESSAGE } from "./message";
import { SMS_PHONE_NUMBER_REGEX } from "./patterns";

export const smsPhoneNumberSchema = z
  .string()
  .min(1, PHONE_NUMBER_REQUIRED_MESSAGE)
  .regex(SMS_PHONE_NUMBER_REGEX, SMS_PHONE_NUMBER_FORMAT_MESSAGE);
